import { render, staticRenderFns } from "./TableAction.vue?vue&type=template&id=6f70b818&scoped=true"
import script from "./TableAction.vue?vue&type=script&lang=ts"
export * from "./TableAction.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f70b818",
  null
  
)

export default component.exports